export const CREATE_ADMIN_EMERGENCY_ALERT = "CREATE_ADMIN_EMERGENCY_ALERT";   
export const RETRIEVE_ADMIN_EMERGENCY_ALERT = "RETRIEVE_ADMIN_EMERGENCY_ALERT";
export const RETRIEVESINGLE_ADMIN_EMERGENCY_ALERT = "RETRIEVESINGLE_ADMIN_EMERGENCY_ALERT";
export const UPDATE_ADMIN_EMERGENCY_ALERT = "UPDATE_ADMIN_EMERGENCY_ALERT";   
export const DELETE_ADMIN_EMERGENCY_ALERT = "DELETE_ADMIN_EMERGENCY_ALERT";   
